import { useMutation, useQuery } from '@apollo/client';
import React, { FC } from 'react';
import AddIcon from '@material-ui/icons/Add';
import { GET_ADMINS } from './graphql/queries';
import QueryGuard from '../../../Components/QueryGuard';
import { Avatar, Card, CardHeader, Fab, IconButton, makeStyles } from '@material-ui/core';
import { DELETE_ADMIN } from './graphql/mutations';
import { useUserDetails } from '../../../UserContext/UserContex';
import DeleteIcon from '@material-ui/icons/Delete';
import { useNavigate } from 'react-router-dom';
import { Admin } from './types';
import { red } from '@material-ui/core/colors';
import { getInitials } from '../../../utils/utils';

const useStyles = makeStyles((theme) => ({
  fab: {
    position: 'fixed',
    bottom: '2rem',
    right: '2rem'
  }
}));

const Admins: FC = () => {
  const { id } = useUserDetails();
  const navigate = useNavigate();
  const { fab } = useStyles();
  const { data, loading, error, refetch } = useQuery(GET_ADMINS);
  const [deleteAdmin] = useMutation(DELETE_ADMIN, {
    onCompleted: () => {
      refetch();
    }
  });
  const handleDelete = async (email: string) => {
    await deleteAdmin({
      variables: { adminId: id, email }
    });
  };

  const renderAction = (admin: Admin) => {
    if (id === admin.id) {
      return null;
    }

    return (
      <IconButton onClick={() => handleDelete(admin.email)}>
        <DeleteIcon />
      </IconButton>
    );
  };

  return (
    <>
      <h1 className="my-6 text-3xl">Admins</h1>
      <Fab color="primary" onClick={() => navigate('/operations/admins/new')} aria-label="add" className={fab}>
        <AddIcon />
      </Fab>
      <QueryGuard data={data} loading={loading} error={!!error}>
        {data &&
          data.admins &&
          data.admins.map((admin: Admin) => (
            <Card style={{ marginBottom: '8px' }}>
              <CardHeader
                avatar={<Avatar style={{ backgroundColor: red[500] }}>{getInitials(admin.firstName, admin.lastName)}</Avatar>}
                title={`${admin.firstName} ${admin.lastName}`}
                subheader={admin.email}
                action={renderAction(admin)}
              />
            </Card>
          ))}
      </QueryGuard>
    </>
  );
};

export default Admins;
